// Tides – Standard Ports exercises (Cairns, Bugatti Reef, Urangan, Gladstone, Townsville)
// Extracted from live WordPress block attributes (allships.com.au), tidesStandardPorts
const tidesStandardPorts = [
  {
    tabGroup: "exercises",
    tideform_published: true,
    tideform_description: "Record times and heights for the tides for Cairns standard port on 5th of November 2025.  Calculate the tidal range between high and low water for 09:35.",
    tideform_tab_title: "Exercise 1 - Cairns",
    tideform_show_tidal_range: true,
    tideform_std_row1_tide: "LW",
    tideform_std_row1_time: "02:12",
    tideform_std_row1_height: "0.21",
    tideform_std_row2_tide: "HW",
    tideform_std_row2_time: "08:45",
    tideform_std_row2_height: "3.03",
    tideform_std_row3_tide: "LW",
    tideform_std_row3_time: "14:39",
    tideform_std_row3_height: "0.83",
    tideform_std_row4_tide: "HW",
    tideform_std_row4_time: "20:27",
    tideform_std_row4_height: "2.62",
    tideform_range_hw: "3.03",
    tideform_range_lw: "0.83",
    tideform_range_range: "2.2",
    tideform_show_secondary_port: false,
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
  {
    tabGroup: "exercises",
    tideform_published: true,
    tideform_description: "Record times and heights for the tides for Bugatti Reef standard port on 2nd of April 2025.  Calculate the tidal range between high and low water for 13:30.",
    tideform_tab_title: "Exercise 2- Bugatti Reef",
    tideform_show_tidal_range: true,
    tideform_std_row1_time: "00:40",
    tideform_std_row1_height: "2.99",
    tideform_std_row2_time: "06:50",
    tideform_std_row2_height: "1.12",
    tideform_std_row3_time: "12:41",
    tideform_std_row3_height: "2.17",
    tideform_std_row4_time: "18:33",
    tideform_std_row4_height: "0.78",
    tideform_range_hw: "2.17",
    tideform_range_lw: "0.78",
    tideform_range_range: "1.39",
    tideform_show_secondary_port: false,
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_std_row1_tide: "HW",
    tideform_std_row2_tide: "LW",
    tideform_std_row3_tide: "HW",
    tideform_std_row4_tide: "LW",
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
  {
    tabGroup: "exercises",
    tideform_published: true,
    tideform_description: "Record times and heights for the tides for Urangan standard port on 24th of January 2025.  Calculate the tidal range between high and low water for 15:45.",
    tideform_tab_title: "Exercise 3 - Urangan",
    tideform_show_tidal_range: true,
    tideform_std_row1_time: "05:09",
    tideform_std_row1_height: "2.96",
    tideform_std_row2_time: "11:34",
    tideform_std_row2_height: "1.70",
    tideform_std_row3_time: "16:45",
    tideform_std_row3_height: "2.65",
    tideform_std_row4_time: "23:00",
    tideform_std_row4_height: "1.30",
    tideform_range_hw: "2.65",
    tideform_range_lw: "1.70",
    tideform_range_range: "0.95",
    tideform_show_secondary_port: false,
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_std_row1_tide: "HW",
    tideform_std_row2_tide: "LW",
    tideform_std_row3_tide: "HW",
    tideform_std_row4_tide: "LW",
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_result: false,
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
    tideform_tide_result_tidetime: "",
    tideform_tide_result_timediff: "",
    tideform_tide_result_extra_height: "",
    tideform_tide_result_height: "",
  },
  {
    tabGroup: "exercises",
    tideform_published: true,
    tideform_description: "Record times and heights for the tides for Gladstone standard port on 5th of May 2025.  You arrive outside Gladstone at 14:30. Using the Standard Tidal Curve tool link below, interpolate to get the extra water and add it to previous low water height and record the total tide height at above arrival time.",
    tideform_tab_title: "Exercise 4 - Gladstone",
    tideform_show_tidal_range: true,
    tideform_std_row1_time: "03:49",
    tideform_std_row1_height: "3.68",
    tideform_std_row2_time: "10:30",
    tideform_std_row2_height: "1.43",
    tideform_std_row3_time: "16:46",
    tideform_std_row3_height: "3.11",
    tideform_std_row4_time: "22:43",
    tideform_std_row4_height: "1.64",
    tideform_range_hw: "3.11",
    tideform_range_lw: "1.43",
    tideform_range_range: "1.68",
    tideform_required_total: "2.10",
    tideform_required_actuallw: "1.43",
    tideform_required_tidetime: "11:15",
    tideform_show_tide_result: true,
    tideform_tide_result_tidetime: "14:30",
    tideform_tide_result_timediff: "-02:16",
    tideform_tide_result_extra_height: "0.85",
    tideform_tide_result_height: "2.28",
    tideform_show_secondary_port: false,
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_std_row1_tide: "HW",
    tideform_std_row2_tide: "LW",
    tideform_std_row3_tide: "HW",
    tideform_std_row4_tide: "LW",
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_tideheight: "",
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
  },
  {
    tabGroup: "exercises",
    tideform_published: true,
    tideform_description: "Record times and heights for the tides for Townsville standard port on 5th of October 2025.  You arrive outside the harbour at 03:45. Using the Standard Tidal Curve tool link below, interpolate to get the extra water and add it to previous low water height and record the total tide height at above arrival time.",
    tideform_tab_title: "Exercise 5 - Townsville",
    tideform_show_tidal_range: true,
    tideform_std_row1_tide: "LW",
    tideform_std_row1_time: "01:52",
    tideform_std_row1_height: "0.70",
    tideform_std_row2_tide: "HW",
    tideform_std_row2_time: "07:19",
    tideform_std_row2_height: "3.07",
    tideform_std_row3_tide: "LW",
    tideform_std_row3_time: "13:24",
    tideform_std_row3_height: "0.59",
    tideform_std_row4_tide: "HW",
    tideform_std_row4_time: "19:39",
    tideform_std_row4_height: "3.62",
    tideform_range_hw: "3.07",
    tideform_range_lw: "0.70",
    tideform_range_range: "2.37",
    tideform_show_tide_result: true,
    tideform_tide_result_tidetime: "03:45",
    tideform_tide_result_timediff: "-03:34",
    tideform_tide_result_extra_height: "0.45",
    tideform_tide_result_height: "1.15",
    tideform_show_secondary_port: false,
    tideform_show_vessel_requirements: false,
    tideform_show_low_water: false,
    tideform_show_required_tide: false,
    tideform_sec_row1_tide: "HW",
    tideform_sec_row1_timediff: "",
    tideform_sec_row1_ratio: "",
    tideform_sec_row1_constant: "",
    tideform_sec_row2_tide: "LW",
    tideform_sec_row2_timediff: "",
    tideform_sec_row2_ratio: "",
    tideform_sec_row2_constant: "",
    tideform_sec_table2_row1_tide: "HW",
    tideform_sec_table2_row1_time: "",
    tideform_sec_table2_row1_height: "",
    tideform_sec_table2_row2_tide: "LW",
    tideform_sec_table2_row2_time: "",
    tideform_sec_table2_row2_height: "",
    tideform_sec_table2_row3_tide: "HW",
    tideform_sec_table2_row3_time: "",
    tideform_sec_table2_row3_height: "",
    tideform_sec_table2_row4_tide: "LW",
    tideform_sec_table2_row4_time: "",
    tideform_sec_table2_row4_height: "",
    tideform_vessel_ukc: "",
    tideform_vessel_draught: "",
    tideform_vessel_total: "",
    tideform_vessel_charteddepth: "",
    tideform_vessel_requiredheight: "",
    tideform_lowwater_chartlat: "",
    tideform_lowwater_lw: "",
    tideform_lowwater_total: "",
    tideform_required_total: "",
    tideform_required_actuallw: "",
    tideform_required_tideheight: "",
    tideform_required_tidetime: "",
    tideform_show_tide_time: false,
    tideform_tide_time_extrawater: "",
    tideform_tide_time_earliest: "",
  },
];

export default tidesStandardPorts;
